import gql from "graphql-tag";

import {useQuery} from "@repo/data-gql";
import {gqlOp} from "@repo/data-gql-core";
import {RequestInfo} from "@repo/shared-core";

import useProfile from "#data-access/use-profile.ts";

import type {
    getUserActiveEnrollmentGroups,
    getUserActiveEnrollmentGroupsVariables,
} from "./__graphql-types__/getUserActiveEnrollmentGroups.ts";

export const USER_ENROLLMENT_GROUPS_QUERY = gqlOp<
    getUserActiveEnrollmentGroups,
    getUserActiveEnrollmentGroupsVariables
>(gql`
    query getUserActiveEnrollmentGroups {
        user {
            id
            aiGuideActiveEnrollmentGroups
        }
    }
`);
// This hook returns a boolean determining whether the user
// is eligible to have a referral code and make referrals
export default function useTeacherIsEligibleForReferrals(): boolean {
    const profileResult = useProfile();
    const [queryResult] = useQuery(USER_ENROLLMENT_GROUPS_QUERY);
    // Ineligible if user is not in the US
    if (RequestInfo.remoteCountry.toLowerCase() !== "us") {
        return false;
    }

    if (
        !profileResult ||
        profileResult.status !== "success" ||
        !profileResult.profile ||
        !queryResult ||
        queryResult.status !== "success" ||
        !queryResult.data.user
    ) {
        return false;
    }

    // Ineligible if user does not have AI Guide enabled
    if (!profileResult.profile.get("isAIGuideEnabled")) {
        return false;
    }

    // Ineligible if user does not have the TEACHERS_FREE access plan
    if (
        !queryResult.data.user.aiGuideActiveEnrollmentGroups?.includes(
            "TEACHERS_FREE",
        )
    ) {
        return false;
    }

    // Ineligible if user does not have access to the teacher persona
    if (!profileResult.profile.get("hasAccessToAIGuideTeacher")) {
        return false;
    }

    // Ineligible if user is part of a district
    if (profileResult.profile.get("includesDistrictOwnedData")) {
        return false;
    }

    return true;
}
